var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 196,
    height: 263,
    viewBox: "0 0 196 263",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4 38.9351L0 77.7351V155.868V234.002L24.4 248.268C37.8667 256.135 49.2 262.535 49.4667 262.535C49.7333 262.535 49.8667 227.868 49.7333 185.602C49.4667 143.202 49.7333 107.868 50.4 107.068C50.9333 106.268 70.1333 94.6685 93.0667 81.2018L134.667 56.9351L140.8 60.5351L146.8 64.0018L146.4 70.9351L146 77.7351L109.733 98.9351L73.3333 120.135V148.802C73.3333 171.202 73.7333 177.335 75.0667 176.802C75.8667 176.402 103.333 160.535 136 141.468L195.333 106.802L195.733 70.8018L196 34.9351L166 17.4685C149.6 7.73514 135.333 -0.131524 134.4 0.00180922C133.467 0.00180922 102.8 17.4685 66.4 38.9351Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductflow);
export default __webpack_public_path__ + "static/media/productflow.306a4795e77c8a9052b397bf6fe6c766.svg";
export { ForwardRef as ReactComponent };